import axios from "axios";
import { loadConfig, getToken } from "../utility";

let config = await loadConfig();

export default function UserController() {
	//> login
	this.login = async function (mobile, password, altchaResponse) {
		let result = { isSuccess: true, message: "Success", value: null };
		try {
			const response = await axios.request({
				method: "post",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}User/Login`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
				},
				data: JSON.stringify({
					mobile: mobile,
					password: password,
					altchaResponse: altchaResponse,
				}),
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (
				error.response &&
				(error.response.status === 400 || error.response.status === 400)
			)
				result.message = error.response.data;
		}
		return result;
	};

	//> register
	this.register = async function (mobile, password, confirmPassword) {
		let result = { isSuccess: true, message: "Success", value: null };
		try {
			const response = await axios.request({
				method: "post",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}User/Register`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
				},
				data: JSON.stringify({
					mobile: mobile,
					password: password,
					confirmPassword: confirmPassword,
				}),
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (
				error.response &&
				(error.response.status === 400 || error.response.status === 400)
			)
				result.message = error.response.data;
		}
		return result;
	};

	//> forgetPassword
	this.forgetPassword = async function (mobile) {
		let result = { isSuccess: true, message: "Success", value: null };
		try {
			const response = await axios.request({
				method: "post",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}User/ForgetPassword`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
				},
				data: JSON.stringify({
					mobile: mobile,
				}),
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> changePassword
	this.changePassword = async function (
		mobile,
		verifyCode,
		newPassword,
		confirmNewPassword
	) {
		let result = { isSuccess: true, message: "Success", value: null };
		try {
			const response = await axios.request({
				method: "post",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}User/ChangePassword`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
				},
				data: JSON.stringify({
					mobile: mobile,
					verifyCode: verifyCode,
					newPassword: newPassword,
					confirmNewPassword: confirmNewPassword,
				}),
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (
				error.response &&
				(error.response.status === 400 || error.response.status === 400)
			)
				result.message = error.response.data;
		}
		return result;
	};

	//> getProfile
	this.getProfile = async function () {
		let result = {
			isSuccess: true,
			message: "Success",
			value: {
				userId: "",
				mobile: "",
				firstName: "",
				lastName: "",
				fullName: "",
				nationalId: "",
				email: "",
				gender: false,
				BirthDate: "",
				cardNumber: "",
				decile: 0,
				offPercent: 0,
				levelName: "",
				StateId: "",
				CityId: "",
				StoreId: "",
				cityName: "",
				cityFullName: "",
				membershipStatus: "",
				membershipExpireDate: null,
				membershipRemainDays: 0,
				membershipAmount: 0,
				isProfileCompleted: false,
				jobType: "Worker",
				jobTitle: "",
			},
		};
		const token = getToken();
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}App/User/GetProfile`,
				headers: {
					accept: "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> updateProfile
	this.updateProfile = async function (
		firstName,
		lastName,
		gender,
		birthDate,
		cardNumber,
		isNonIranian,
		nationality,
		nationalId,
		cityId,
		jobType,
		jobTitle
	) {
		let result = { isSuccess: true, message: "Success", value: null };
		const token = getToken();
		try {
			const response = await axios.request({
				method: "post",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}User/UpdateProfile`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: JSON.stringify({
					firstName: firstName,
					lastName: lastName,
					gender: gender,
					birthDate: birthDate ? new Date(birthDate) : null,
					cardNumber: cardNumber,
					isNonIranian: isNonIranian,
					nationality: nationality,
					nationalId: nationalId,
					cityId: cityId,
					jobType: jobType,
					jobTitle: jobTitle,
				}),
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getFamilies
	this.getFamilies = async function () {
		let result = {
			isSuccess: true,
			message: "Success",
			value: [],
		};
		const token = getToken();
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}App/User/GetFamilies`,
				headers: {
					accept: "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
			result.value.map((item) => {
				if (item.birthDate) item.birthDate = new Date(item.birthDate);
			});
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> updateFamily
	this.updateFamily = async function (
		userFamilyId,
		relationship,
		gender,
		firstName,
		lastName,
		birthDate,
		nationalId,
		mobile
	) {
		let result = { isSuccess: true, message: "Success", value: null };
		const token = getToken();
		try {
			const response = await axios.request({
				method: "post",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}App/User/UpdateFamily`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: JSON.stringify({
					userFamilyId: userFamilyId,
					relationship: relationship,
					gender: gender,
					firstName: firstName,
					lastName: lastName,
					birthDate: birthDate ? new Date(birthDate) : null,
					nationalId: nationalId,
					mobile: mobile,
				}),
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			console.warn(error.response);
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> deleteFamily
	this.deleteFamily = async function (userFamilyId) {
		let result = { isSuccess: true, message: "Success", value: null };
		const token = getToken();
		try {
			const response = await axios.request({
				method: "post",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}App/User/DeleteFamily?userFamilyId=${userFamilyId}`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			console.warn(error.response);
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> isAdminUser
	this.isAdminUser = async function () {
		let result = false;
		const token = getToken();
		if (!token) return result;
		try {
			const response = await axios.request({
				method: "get",
				url: `${config.apiBaseUrl}User/IsAdmin`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result = response.data;
		} catch (error) {
			console.warn(error.toString());
			result = false;
		}
		return result;
	};

	//> createMembershipOrder
	this.createMembershipOrder = async function (decile, couponCode) {
		let result = { isSuccess: true, message: "Success", value: null };
		const token = getToken();
		try {
			const response = await axios.request({
				method: "post",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/CreateMembershipOrder`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: JSON.stringify({
					returnUrl: window.location.origin + "/#call-back-membership",
					notes: "پرداخت حق عضویت شش ماهه باشگاه کارگران کشور",
					decile: decile,
					couponCode: couponCode,
				}),
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getCoupon
	this.getCoupon = async function (code, couponType) {
		let result = {
			isSuccess: true,
			message: "Success",
			value: {
				couponId: "",
				code: "",
				offPercent: 0,
			},
		};
		const token = getToken();
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetCoupon?code=${code}&couponType=${couponType}`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getOrder
	this.getOrder = async function (orderNumber) {
		let result = { isSuccess: true, message: "Success", value: null };
		const token = getToken();
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetOrder?orderNumber=${orderNumber}`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> checkRedirect
	this.checkRedirect = async function (ticket) {
		let result = { isSuccess: true, message: "Success", value: null };
		try {
			const response = await axios.request({
				method: "post",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}App/User/CheckRedirect`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
				},
				data: JSON.stringify({
					ticket: ticket,
				}),
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (
				error.response &&
				(error.response.status === 400 || error.response.status === 401)
			)
				result.message = error.response.data;
		}
		return result;
	};
	//
}
